<template>
    <div class="ibox-container" :class="{'container-fluid-grid': !$appUtils.isMobile()}">
        <div :class="{'row': !$appUtils.isMobile()}">
            <div :class="{'col-sm-12': !$appUtils.isMobile()}">
                <div class="ibox">
                    <div class="ibox-header" :class="type" v-if="$slots.title || $slots.tabs">
                        <div class="title" v-if="$slots.title"><slot name="title">Título</slot></div>
                        <div class="tabs"><slot name="tabs"/></div>
                    </div>

                    <div class="ibox-content" v-if="$slots.content">
                        <slot name="content">Conteúdo</slot>
                    </div>

                    <div class="ibox-footer" :class="{mobile: $appUtils.isMobile()}" v-if="$slots.footer">
                        <slot name="footer"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Ibox",
        props: {
            type: {
                type: String,
                default: 'default',
                validator: v => /(default|tab_right)/gi.test(v)
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/variables';
    @import '../../assets/css/grid';

    .ibox {
        clear: both;
        margin-bottom: 15px;
        margin-top: 15px;
        padding: 0;
    }
    .ibox.collapsed .ibox-content {
        display: none;
    }
    .ibox.collapsed .fa.fa-chevron-up:before {
        content: "\f078";
    }
    .ibox.collapsed .fa.fa-chevron-down:before {
        content: "\f077";
    }
    .ibox:after,
    .ibox:before {
        display: table;
    }
    .ibox-header {
        &.default {
            background-color: $theme_color_six;
            border-color: #e7eaec;
            border-style: solid solid none;
            border-width: 2px 0 0;
            color: $theme_color_four;
            margin-bottom: 0;
            min-height: 40px;
            font-weight: 300;
            font-family: 'Montserrat', sans-serif;
            position: relative;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto;
            align-items: flex-end;

            .title {
                display: flex;
                align-items: center;
                padding-left: 10px;

                h5 {
                    font-size: 1em;
                    font-weight: 300;
                    margin: 0;
                    padding: 0;

                    svg {
                        width: 1.2em;
                        height: 1.2em;
                        margin-right: 10px;
                    }
                }
            }
        }

        &.tab_right {
            min-height: 40px;
            position: relative;
            font-weight: 300;
            font-family: 'Montserrat', sans-serif;
            display: grid;
            grid-template-columns: 300px 1fr;
            grid-template-rows: auto;
            justify-items: stretch;
            align-items: stretch;
            border: none;
            background-color: $theme_color_six;
            color: $theme_color_four;


            .title {
                text-align: left;
                display: flex;
                align-items: center;
                padding-left: 10px;

                h5 {
                    font-size: 1em;
                    font-weight: 300;
                    margin: 0;
                    padding: 0;

                    svg {
                        width: 1.2em;
                        height: 1.2em;
                        margin-right: 10px;
                    }
                }
            }

            .tabs ul {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                list-style: none;
                margin: 0;
                padding: 0;
                height: 100%;

                li {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-left: 10px;
                    padding-right: 10px;
                    background-color: $theme_color_six;
                    border-top: 3px solid $theme_color_six;
                    transition: background-color .2s ease, border-top-color .2s ease;
                    height: 100%;
                    cursor: pointer;
                    border-top-left-radius: 3px;
                    border-top-right-radius: 3px;


                    &:hover a {
                        color: $theme_color_one;
                    }

                    a {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        text-decoration: none;
                        color: $theme_color_four;
                        transition: color .2s ease;
                        font-size: .9em;

                        .label {
                            margin-left: 5px;
                        }

                        .badge {
                            line-height: 1.1em;
                            background: red;
                            margin-left: 2px;
                            margin-top: -15px;
                            color: #fff;
                            padding: 1px 3px 0;

                            text-align: center;
                            display: inline-block;
                            min-width: 1.1em;
                            height: 1.1em;
                            font-size: .75em;
                            border-radius: 2px 2px 2px 2px;
                            box-shadow: 1px 1px 2px 0 black;
                            font-weight: 700;

                            .theme-1 {
                                background: $theme_color_one
                            }
                        }

                        svg {
                            width: 1em;
                            height: 1em;
                        }
                    }


                    &:target, &.active {
                        border-top: 3px solid $theme_color_one;
                        background-color: $theme_color_four;
                        color: $theme_color_six;

                        a {
                            color: $theme_color_six;
                        }
                    }
                }
            }
        }
    }
    .ibox-content {
        background-color: #fff;
        color: inherit;
        padding: 15px 20px 20px 20px;
        border-color: #e7eaec;
        border-image: none;
        border-style: solid solid none;
        border-width: 1px 0;
        border-top: none;
    }
    .ibox-footer {
        color: inherit;
        border-top: 1px solid #e7eaec;
        font-size: 90%;
        background: #fff;
        padding: 10px 15px;

        &.mobile {
            padding-bottom: 100px;
        }
    }

    .ibox-container {
        background-color: $ibox_container;
    }

    hr {
        border-top: #e7eaec;
    }

    @media (min-width: 360px), (min-width: 576px) {
        .ibox {
            margin: 0;
        }
        .ibox-content {
            padding-top: 15px;
            padding-right: 0;
            padding-left: 0;
        }
    }

    @media (max-width: 576px) {
        .ibox-header {
            &.tab_right {
                grid-template-columns: 1fr;

                .tabs {
                    overflow-x: auto;
                    ul {
                        justify-content: flex-start;

                        li {
                            text-align: center;
                            border-top-left-radius: 0;
                            border-top-right-radius: 0;

                            a {
                                font-size: .8em;

                                svg {
                                    width: 1.2em;
                                    height: 1.2em;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
